module.exports = __webpack_public_path__ + "static/media/ortshilfe.127fadfa.svg";